export function isValidURL(url: string): boolean {
  // Parsed, not pattern-matched. The regex this replaced allowed only
  // alphanumerics, dots and hyphens in the path and nothing after it, so a
  // query string, an underscore or a port made a perfectly good feed URL
  // "invalid" — and since the continue button is gated on this, the page just
  // stopped responding with no explanation. Google Sheets export links, which
  // always carry a query, could never be entered at all.
  if (!url || /\s/.test(url)) return false

  try {
    // The field accepts a bare host; the API adds the protocol on the way in.
    const parsed = new URL(
      /^[a-z][a-z0-9+.-]*:\/\//i.test(url) ? url : `https://${url}`,
    )

    if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:')
      return false

    // A hostname with no dot is a local name, not a feed anyone can reach.
    return parsed.hostname.includes('.') && !parsed.hostname.endsWith('.')
  } catch {
    return false
  }
}
